<template>
  <div class="personal-center-container">
    <el-row class="problem-body">
      <el-col :span="4" class="problem-lside">
        <ul>
          <li>
            <a href="javascript:void(0);" class="nli">个人中心<b class="arrow"></b></a>
            <ul class="ulson" style="display: block;">
              <li><a href="#">订单管理</a></li>
              <li><a href="/page.html#/pages/plateform/address">收货地址</a></li>
              <li><a href="/page.html#/pages/plateform/personalInfo">个人信息</a></li>
            </ul>
          </li>
        </ul>
      </el-col>

      <el-col :span="20" class="problem-rside">
        <div class="probar">
          <a href="#">个人中心-订单列表</a>
        </div>
        <order-list ref="orderList"></order-list>
      </el-col>
    </el-row>

    <confirm-order-dialog ref="confirmOrderDialog"></confirm-order-dialog>
    <evaluate-dialog ref="evaluateDialog"></evaluate-dialog>
    <logistic-dialog ref="logisticDialog"></logistic-dialog>
    <return-dialog ref="returnDialog"></return-dialog>
  </div>
</template>

<script>
import OrderList from '@/components/platform/personalCenter/OrderList'
// import ConfirmOrderDialog from '@/components/platform/personalCenter/ConfirmOrderDialog'
// import EvaluateDialog from '@/components/platform/personalCenter/EvaluateDialog'
// import LogisticDialog from '@/components/platform/personalCenter/LogisticDialog'
// import ReturnDialog from '@/components/platform/personalCenter/ReturnDialog'

export default {
  name: 'PersonalCenter',
  components: {
    OrderList,
    // ConfirmOrderDialog,
    // EvaluateDialog,
    // LogisticDialog,
    // ReturnDialog
  },
  mounted() {
    this.$nextTick(() => {
      // $(".problem-lside a.nli").each(function() {
      //   $(this).click(function() {
      //     $(this).next("ul.ulson").slideToggle(200)
      //     $(this).children("b").toggleClass("arrow")
      //   })
      // })
    })
  }
}
</script>

<style scoped>
.personal-center-container {
  width: 100%;
}

.problem-body {
  display: flex;
  min-height: 600px;
}

.problem-lside {
  background: #f5f5f5;
  padding: 20px;
}

.problem-lside ul {
  list-style: none;
  padding: 0;
}

.problem-lside li {
  margin-bottom: 10px;
}

.problem-lside a {
  color: #333;
  text-decoration: none;
}

.problem-rside {
  padding: 20px;
}

.probar {
  padding: 10px;
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: 20px;
}

.nli {
  display: block;
  padding: 5px 0;
  font-weight: bold;
}

.ulson {
  padding-left: 15px;
}

.arrow {
  display: inline-block;
  margin-left: 5px;
  transition: transform 0.2s;
}

.arrow.active {
  transform: rotate(90deg);
}
</style>